import {
  I2cInput,
  I2cListItem,
  I2cRadio,
  I2cRadioGroup,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { serverToServerCommunicationOptions, i2cServerOptionSelect } from "./stringUtils";
import { validationSchemaServerToServerCommunication } from "./ValidationSchema";

const ServertoServerCommunication = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaServerToServerCommunication),
    mode: "all",
    reValidateMode: "all",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like: "",
      server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other: "",
      server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement: "",
      server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other: "",
    },
  });

  const {
    formState: { errors },
  } = methods;

  const fields = [
    "server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like",
    "server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other",
    "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement",
    "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other",
  ];

  // Handle value changes and update parent state
  const handleValueChanges = React.useCallback(() => {
    const values = methods.getValues();
    setAddFormData((prev) => ({
      ...prev,
      5: {
        ...prev[5],
        "5_1": { ...values },
      },
    }));
  }, [methods, setAddFormData]);

  // Load existing form data
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        const value = formDataJson[5]?.["5_1"]?.[field];
        if (value !== undefined && value !== null) {
          methods.setValue(field, value);
        }
      });
      methods.trigger();
      handleValueChanges();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching]);

  // Trigger validation when component mounts
  useEffect(() => {
    methods.trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update form validation state when errors change
  useEffect(() => {
    const errorsLength = Object.keys(errors)?.length;
    if (errorsLength === 0) {
      setFormValidStates("5_1", true);
    } else {
      setFormValidStates("5_1", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  const handleRadioChange = (fieldName, value, fieldsToReset = {}) => {
    methods.setValue(fieldName, value, { shouldValidate: true });

    // Clear dependent fields if needed
    Object.keys(fieldsToReset).forEach(key => {
      methods.setValue(key, fieldsToReset[key]);
    });

    handleValueChanges();
  };

  const handleInputChange = (fieldName, value) => {
    methods.setValue(fieldName, value, { shouldValidate: true });
    handleValueChanges();
  };

  const handleServerToServerCommunicationChange = (e) => {
    const value = e.target?.value || e;
    handleRadioChange(
      "server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like",
      value,
      value !== "other" ? {
        server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other: ""
      } : {}
    );
  };

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="sub-section">
              <I2cRadioGroup
                label="What type of server-to-server communication would you like to use?"
                value={methods.watch("server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like")}
                onI2cChange={handleServerToServerCommunicationChange}
              >
                <div i2c-grid="grid gap-sm">
                  {serverToServerCommunicationOptions.map((radio, index) => (
                    <I2cListItem
                      key={index}
                      i2c-grid="4@md"
                      variant="receipt"
                      label={radio.label}
                      sublabel=" "
                      type="checkbox"
                    >
                      <I2cRadio slot="prefix" filled value={radio.value} />
                    </I2cListItem>
                  ))}
                </div>
              </I2cRadioGroup>
              {errors.server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like && (
                <ErrorMessage message={errors.server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like.message} />
              )}
              {methods.watch(
              "server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like",
            ) === "other" && (
              <>
                <div i2c-grid="grid gap-sm" className="sub-section">
                  <div i2c-grid="4@md" className="mt-16">
                    <div className="single-field-wrapper">
                      <I2cInput
                        className="single-input-field"
                        onI2cInput={(e) =>
                          handleInputChange(
                            "server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other",
                            e.target.value,
                          )
                        }
                        value={methods.watch(
                          "server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other",
                        )}
                        placeholder="Please Specify"
                        label="Please Specify"
                        name="server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other"
                        size="large"
                        invalid={
                          errors.server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other
                            ? true
                            : false
                        }
                      />
                      {errors.server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other && (
                        <ErrorMessage
                          show={true}
                          message={
                            errors
                              .server_to_server_communication_link_for_file_exchange_what_type_of_communication_would_you_like_other
                              .message
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            </div>
            
          </div>
        </div>
        <div className="sub-section" i2c-grid="12">
          <I2cRadioGroup
            label="Would you like to use i2c server for file placement?"
            value={methods.watch(
              "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement",
            )}
            onI2cChange={(e) =>
              handleRadioChange(
                "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement",
                e.target?.value || e,
                (e.target?.value || e) !== "other"
                  ? {
                      server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other:
                        "",
                    }
                  : {},
              )
            }
          >
            <div i2c-grid="grid gap-sm">
              {i2cServerOptionSelect.map((radio, index) => (
                <I2cListItem
                  key={index}
                  i2c-grid="4@md"
                  variant="receipt"
                  label={radio.label}
                  type="checkbox"
                >
                  <I2cRadio slot="prefix" filled value={radio.value} />
                </I2cListItem>
              ))}
            </div>
          </I2cRadioGroup>
          {errors.server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement && (
            <ErrorMessage
              show={true}
              message={
                errors
                  .server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement
                  .message
              }
            />
          )}
          {methods.watch(
            "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement",
          ) === "other" && (
            <div i2c-grid="grid gap-sm" className="mt-16">
              <div i2c-grid="4@md">
                <div className="single-field-wrapper">
                  <I2cInput
                    className="single-input-field"
                    onI2cInput={(e) =>
                      handleInputChange(
                        "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other",
                        e.target.value,
                      )
                    }
                    value={methods.watch(
                      "server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other",
                    )}
                    placeholder="Please Specify"
                    label="Please Specify"
                    name="server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other"
                    size="large"
                    invalid={
                      errors.server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other
                        ? true
                        : false
                    }
                  />
                  {errors.server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other && (
                    <ErrorMessage
                      show={true}
                      message={
                        errors
                          .server_to_server_communication_link_for_file_exchange_would_you_like_to_use_i2c_server_for_file_placement_other
                          .message
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ServertoServerCommunication;
